import { timeHelper } from './time.helper'

const courseDay = (c) => {
  const days = c.lessons.map((l) => l.day)
  const daysUnique = [...new Set(days)].sort()
  return daysUnique.map((d) => timeHelper.dayOfWeek(d)).join(', ')
}

export const uiHelper = {
  courseDay
}
